import React, { useMemo, useCallback } from 'react';
import { orderBy } from 'lodash';

import Tooltip from '@material-ui/core/Tooltip';
import WarningIcon from '@material-ui/icons/Error';
import BatchControlIcon from '../../assets/icons/BatchControlIcon';

import Table from '../shared/table/Table';

import { caseUsageTypes, setAllocationStatuses } from '../../constants/enums';

import './counts.scss';

const { RETURNED } = setAllocationStatuses;

const findValue = (usage, key) => {
  if (!usage || !usage.values) {
    return '';
  }

  const value = usage.values.find((v) => v.label === key);
  return value ? value.value : '';
};

const CountInventoryTable = (props) => {
  const {
    scans,
    onSelect,
    selected,
    gtinRefActive,
    gtinReference,
    users,
    onApproveClick,
    orderClosed,
    proformaSent,
    proformaGenerated,
    isSubmitted,
    tags = [],
    rowColor = 'var(--app-table-row)',
    rowBorderColor = 'transparent',
  } = props;

  const columns = useMemo(() => {
    const arr = [
      { title: 'qty', field: 'quantity', type: 'default', sort: true },
      { title: 'added by', field: 'counterName', type: 'default', sort: true },
      { title: 'date', field: 'createdAt', type: 'date', sort: true },
      { title: 'type', field: 'scanType', type: 'type', sort: true },
      { title: '', field: 'batchControl', type: 'custom', formatter: (value) => !!value && <BatchControlIcon color={RETURNED.color} />}
    ]

    if (onApproveClick && isSubmitted) {
      arr.push({
        title: 'Approval',
        field: 'approved',
        type: 'custom',
        formatter: (value, row) => {
          const refValue = findValue(row, 'REF');
          return !!refValue ? (
            <div
              style={{ width: 'fit-content' }}
              onClick={(e) => {
                e.stopPropagation();
                if (!orderClosed && !proformaSent && !proformaGenerated) {
                  onApproveClick(row.id, !value);
                }
              }}
            >
              {value ? (
                  <div className="sets-table__allocation-status-cell SHIPPED">
                    Approved
                  </div>
              ) : (
                <div className="sets-table__allocation-status-cell RETURNED">
                  Approve
                </div>
              )}
            </div>
          ) : (
            <Tooltip
              title='Item code data is mandatory'
              aria-label='warning-icon'
            >
              <WarningIcon style={{color: setAllocationStatuses.ASSIGNED.color }} />
            </Tooltip>
          )
        },
      });
    }

    if (gtinRefActive) {
      return [
        { title: 'item', field: 'values', type: 'scans', sort: false, },
        { title: 'gtin ref', field: 'gtinRef', type: 'default', sort: true },
        ...arr,
      ];
    } else {
      return [
        { title: 'item', field: 'values', type: 'scans', sort: false, },
        ...arr,
      ]
    }
  }, [scans, gtinRefActive, orderClosed, isSubmitted, proformaSent, onApproveClick]);

  const findGtinReference = useCallback((scan) => {
    if (scan.type !== caseUsageTypes.implants) {
      return '';
    }

    const gtin = scan.values.find((item) => item.label.toLowerCase() === 'gtin');
    const gtinRef = gtin ? gtinReference.find((item) => item.gtin === gtin.value) : null;

    return gtinRef ? gtinRef.reference : '';
  }, [scans, gtinReference]);

  const getCounterName = useCallback((scan) => {
    const user = users.find((user) => user.uid === scan.userId);
    return user ? `${user.firstName} ${user.lastName}` : '';
  }, [scans, users]);

  return (
    <div style={{ width: '100%' }}>
      <Table
        rows={orderBy(
          scans.map((item) => ({
            ...item,
            gtinRef: findGtinReference(item),
            counterName: getCounterName(item),
          })),
          'counterName'
        )}
        columns={columns}
        onRowClick={onSelect}
        selected={selected}
        rowColor={rowColor}
        rowBorderColor={rowBorderColor}
        checkboxes={false}
        pagination
        additionalData={{ tags }}
      />
    </div>
  );
};

export default CountInventoryTable;
